import { ShieldCheck, Award, Globe, Handshake, Truck, HeartPulse, BadgeCheck, Leaf } from 'lucide-react';

export const PARTNER_ICONS = {
  shield: { Icon: ShieldCheck, label: 'Shield' },
  award: { Icon: Award, label: 'Award' },
  globe: { Icon: Globe, label: 'Globe' },
  handshake: { Icon: Handshake, label: 'Handshake' },
  truck: { Icon: Truck, label: 'Truck' },
  heart: { Icon: HeartPulse, label: 'Heart' },
  badge: { Icon: BadgeCheck, label: 'Badge' },
  leaf: { Icon: Leaf, label: 'Leaf' },
};
